<era-panel>
  <era-panel-header>
    <div class="border-bottom px-3 d-flex align-items-center py-2">
      Location:
      <strong class="ms-2 py-1">
        <era-select-location-list-devices></era-select-location-list-devices>
      </strong>
      
      @if (features.devices.reboot) {
      <div class="ms-auto flex-shrink-1 d-flex align-items-center">
        <era-context-menu>
          <button ngbDropdownItem
                  (click)="openRebootRequest()">Setup reboot</button>
          <button ngbDropdownItem
                  (click)="openSyncModalRequest()">Sync devices</button>
        </era-context-menu>
      </div>
      }
    </div>
  </era-panel-header>
  
  @if (currentLocation$ | async) {
  <era-master-detail flexGrowLeft="2"
                     flexGrowRight="1"
                     [isH2]="false">
    <era-master>
      <era-panel>
        <div class="px-3">
          <era-devices-swapped></era-devices-swapped>
          <era-devices-spare></era-devices-spare>
          <era-devices-assigned></era-devices-assigned>
          <era-devices-housekeeping></era-devices-housekeeping>
          <era-devices-staff></era-devices-staff>
          <era-devices-frontdesk></era-devices-frontdesk>
          <era-devices-bar></era-devices-bar>
          <era-devices-kiosk></era-devices-kiosk>
        </div>
      </era-panel>
    </era-master>
  </era-master-detail>
  }
</era-panel>